// Bundle principale del build (react-scripts): il nome cambia a ogni rilascio
const MAIN_SCRIPT = /\/static\/js\/main\.[0-9a-f]+\.js/;

// Il portale e' una SPA che resta aperta per giorni sui PC di linea: senza un reload continua a eseguire
// il codice caricato all'apertura anche dopo un rilascio. Si confronta il bundle in esecuzione con quello
// indicato dall'index.html sul server: diversi = c'e' una versione nuova da caricare.
export const isNewVersionAvailable = async () => {
    const loaded = Array.from(document.scripts).map((script) => script.src.match(MAIN_SCRIPT)?.[0]).find(Boolean);
    // npm start: niente bundle con hash, controllo disattivato
    if (!loaded) return false;

    try {
        const response = await fetch(process.env.PUBLIC_URL + '/index.html', { cache: 'no-store' });
        const current = (await response.text()).match(MAIN_SCRIPT)?.[0];
        return !!current && current !== loaded;
    } catch {
        // server non raggiungibile: si prosegue con la versione caricata
        return false;
    }
};
